import { render, staticRenderFns } from "./commonPagination.vue?vue&type=template&id=56bd0bfe&scoped=true&"
import script from "./commonPagination.vue?vue&type=script&lang=js&"
export * from "./commonPagination.vue?vue&type=script&lang=js&"
import style0 from "./commonPagination.vue?vue&type=style&index=0&id=56bd0bfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd0bfe",
  null
  
)

export default component.exports